import { Box, Tooltip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { path } from "src/constants/path";
import {
  allowedToDeleteEntity,
  allowedToReadEntity,
  allowedToResetPass,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { employeeColumns as columns } from "../../Helper";

const GetEmployeeTableColumns = ({ handleResetPass, handleDelete, status }) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  const history = useHistory();
  const showEmployeeDetail = (employee) => {
    history.push(`${path.systemEmployee}/${employee.id}`);
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToReadEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-success"
            onClick={() => {
              showEmployeeDetail(item);
            }}
          >
            <i className="bx bx-show"></i>
          </button>
        )}

        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.systemEmployee}/edit/${item.id}`,
            }}
          >
            <button className="btn btn-warning">
              <i className="bx bx-edit"></i>
            </button>
          </Link>
        )}

        <Tooltip title="Reset password">
          {allowedToResetPass(auth?.permissions, permissionsAccessControl) && (
            <button
              onClick={() => handleResetPass(item.id)}
              className="btn btn-warning"
            >
              <i className="bx bx-reset"></i>
            </button>
          )}
        </Tooltip>

        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            onClick={() => handleDelete(item.id)}
            className="btn btn-danger"
          >
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetEmployeeTableColumns;
